import apiClient from "../../services/apiClient";

export async function fetchAllUserAPI() {
  const response = await apiClient.get("/api/v1/user/all", { withAuth: true });
  return response.data;
}
